import { KpiCard } from '@/components/sales/KpiCard';
import type { MigrationReport } from '@/services/migration.service';

interface MigrationSummaryProps {
  report: MigrationReport;
}

export const MigrationSummary = ({ report }: MigrationSummaryProps) => {
  const { summary } = report;
  const committed = report.mode === 'commit';
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
      <KpiCard
        label={committed ? 'Clients Imported' : 'Ready to Import'}
        value={summary.clientsImport}
        tone="success"
      />
      <KpiCard label="Skipped (with reasons)" value={summary.clientsSkipped} tone="destructive" />
      <KpiCard label="Already in CRM" value={summary.clientsExisting} tone="info" />
      <KpiCard
        label={committed ? 'RMs Sent for Approval' : 'New RMs (Approval)'}
        value={summary.rmsNew}
        tone="warning"
      />
      <KpiCard label="RMs Already in CRM" value={summary.rmsExisting} tone="info" />
      <KpiCard label="RMs Not Added" value={summary.rmsRejected} tone="destructive" />
    </div>
  );
};
